import axios from "axios";
import { mockCouponResponse, mockCountries } from "../mocks/mockApi.ts";

const API_BASE_URL = "https://ofm.stran.store/api/usap-jackets";
//const API_BASE_URL = "http://localhost:4000/api/usap-jackets";

const USE_MOCK = false;

const mockResponse = (data, delay = 400) =>
  new Promise((resolve) =>
    setTimeout(() => resolve({ data }), delay)
  );

export const validateCoupon = async (code) => {
  if (USE_MOCK) {
    console.log("Using mocked coupon response");

    if (code !== "TEST") {
      throw new Error("Invalid coupon");
    }

    return mockResponse(mockCouponResponse);
  }

  const response = axios.post(`${API_BASE_URL}/coupon/${code}`,
    {
      parentWindow: window.parent_window,
      rules: window.rules
    }
  );
  return response
};

export const checkout = async (payload) => {
  if (USE_MOCK) {
    console.log("Mock checkout");

    return mockResponse({
      success: true,
      orderId: 123456
    });
  }

  const response = axios.post(`${API_BASE_URL}/checkout`, payload);
  return response
};

export const getCountries = async () => {

  if (USE_MOCK) {
    console.log("Mock countries");
    return mockResponse(mockCountries);
  }
  const response = axios.get(`${API_BASE_URL}/countries`);
  return response
};